import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { loginapidata, setformstatus } from "../../redux/formslice";
import Cookies from "js-cookie";

import Inputbox from "./Inputbox";
import Formvalidation from "../../components/Validation/Formvalidation";

const Login = () => {
    const dispatch = useDispatch();
    const isBigScreen = useMediaQuery({ query: "(min-width: 991px)" });

    const incorrectemailstatus = useSelector(state => state.formslice.incorrectemailstatus);
    const incorrectpasswordstatus = useSelector(state => state.formslice.incorrectpasswordstatus);

    const [formData, setFormData] = useState({
        email: "",
        password: "",
        oscad: Cookies.get("cart_ip_address") || "",
    });

    const [errors, setErrors] = useState({});

    const handleNext = () => {
        dispatch(loginapidata(formData));
    };

    const { handleChange, handleSubmit } = Formvalidation(formData, setFormData, setErrors, handleNext);


    const openregister = () => {
        dispatch(setformstatus(2));
    };

    const openforgotpassword =()=>{
        dispatch(setformstatus(4));
    }

    const isFormValid = formData.email && formData.password;

    return (
        <div className="signup-form">
            {isBigScreen && (
                <div>
                    <div className="FormHeading" style={{ WebkitTextFillColor: "transparent" }}>Login</div>
                    <div className="formsubheading">If you have an account with us, please login.</div>
                    <div className="form-border-bottom"></div>
                </div>
            )}

            <div className="form-mobile-design">
                <div className="inputbox-margin">
                    <Inputbox
                        id="email"
                        type="text"
                          placeholder="Enter Email"
                        value={formData.email}
                        handleChange={handleChange}
                        error={incorrectemailstatus ? "Incorrect Email" : ""}
                    />
                </div>

                <div className="inputbox-margin">
                    <Inputbox
                        id="password"
                        type="password"
                          placeholder="Enter password"
                        value={formData.password}
                        handleChange={handleChange}
                        error={incorrectpasswordstatus ? "Wrong Password" : ""}
                    />
                </div>

                <div className="d-flex justify-content-between align-items-center">
                    <label className="registercheckbox">
                        <div className="d-flex justify-content-between align-items-center">
                            <input
                                type="checkbox"
                                name="agreeTerms"
                                checked={formData.agreeTerms}
                                onChange={handleChange}
                                // className="checkbox-icon"
                            />
                            <span className="ms-2">Remember me</span>
                        </div>
                    </label>
                    <div className="forgotpasswordtext cursor-pointer" onClick={openforgotpassword}>Forgot Password?</div>
                </div>
                <div
                    className={isFormValid ? "activeformsubmitbutton" : "formsubmitbutton"}
                    disabled={!isFormValid}
                    onClick={isFormValid ? () => handleSubmit() : undefined}
                >
                    Login
                </div>

                <div className="formbotton">
                    If you don't have an account,
                    <span className="primarycolor termstitle" onClick={openregister}> Sign up </span>
                </div>
            </div>
        </div>
    );
};

export default Login;
